import { render, staticRenderFns } from "./AnnotationPreview.vue?vue&type=template&id=3abdbd52&scoped=true&"
import script from "./AnnotationPreview.vue?vue&type=script&lang=js&"
export * from "./AnnotationPreview.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationPreview.vue?vue&type=style&index=0&id=3abdbd52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abdbd52",
  null
  
)

export default component.exports